import { Alert, Box, FormControl, TextField } from "@mui/material";
import Combobox from "../../../components/common/Combobox";
import localize from "../../../common/localize";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";

export default function AddNewness({ options, newnessModel, setNewnessModel }) {
  const selected = newnessModel?.AdditionalNewness ?? null;
  const needObservation = selected?.NeedObservation === true;

  return (
    <Box
      className="flex flex-col gap-3 w-full mt-2"
      sx={{ minWidth: { sm: "400px" } }}
    >
      <Combobox
        isRequired
        id="AdditionalNewness"
        fieldLabel={localize.newness}
        fieldOptions={options ?? []}
        fieldValue={selected}
        handleValueChange={(value) =>
          setNewnessModel({
            ...newnessModel,
            AdditionalNewness: value,
            AdditionalNewnessId: value?.Id ?? 0,
          })
        }
      />

      {selected?.Description && (
        <Alert severity="info">
          <span className="text-xs">{selected.Description}</span>
        </Alert>
      )}

      <FormControl fullWidth required={needObservation}>
        <TextField
          required={needObservation}
          multiline
          minRows={3}
          maxRows={6}
          size="small"
          fullWidth
          label={localize.observations}
          variant="outlined"
          value={newnessModel?.Observation ?? ""}
          onChange={(e) =>
            setNewnessModel({
              ...newnessModel,
              Observation: e.target.value,
            })
          }
          InputLabelProps={getInputLabelProps()}
          inputProps={getInputProps()}
        />
      </FormControl>
    </Box>
  );
}
